import React, { useEffect, useState } from "react";
import partnersData from "../data/partnersData";
import "./PartnersStyle.css";

function Partners() {
  const [partners, setPartners] = useState([]);

  useEffect(() => {
    setPartners(partnersData);
  }, []);

  return (
    <div className="partners-container">
      <h1>Our Partners</h1>
      <p>
        IndoDefTech proudly collaborates with leading global partners to bring innovative and 
        future-ready solutions to our clients. Together, we drive excellence and achieve heightened business outcomes.
      </p>

      <div className="partners-grid">
        {partners.map((partner) => (
          <div className="partner-card" key={partner.id}>
            {partner.logo && (
              <img
                src={partner.logo}
                alt={partner.name}
                className="partner-logo"
              />
            )}
            <h3>{partner.name}</h3>
            <p>{partner.description}</p>
          </div>
        ))}
      </div>
    </div>
  );
}

export default Partners;
